// import React from 'react'
// import { Link } from 'react-router-dom';
// import { useAppSelector } from '../../redux/ReduxType';

// interface IChannel{
//     title:string;
//     image?:string;
//     logo?:any;
//     link:string;
// }

// const ChannelList:React.FC<IChannel> = ({title, logo, image, link}) => {

//   const isDark = useAppSelector((state)=>state.theme.isDark)

//   return (
//     <li className={`group ${isDark ? 'hover:bg-darkBg hover:text-white' : 'hover:bg-white hover:text-deepBg'} p-2 rounded-sm w-full`} >
//         <Link className={`flex items-center justify-start gap-2 flex-col sm:flex-row`} to={`/${link}`}>
//         {image ? <img className={`w-3 h-3 rounded-full`} src={image} alt='group one'/> : logo}
//         <span className={``}>{title}</span>
//         </Link>
//     </li>
//   )
// }

// export default ChannelList

// ------- version 2 ---------
import React from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../redux/ReduxType";

interface IChannel {
  title: string;
  image?: string;
  logo?: React.ReactNode;
  link: string;
  isDark?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}

const ChannelList: React.FC<IChannel> = ({
  title,
  image,
  logo,
  link,
  isDark,
  isActive,
  onClick,
}) => {
  const themeDark = useAppSelector((state) => state.theme.isDark);
  const effectiveIsDark = isDark !== undefined ? isDark : themeDark;

  return (
    <li className="w-full">
      <Link
        to={`/${link}`}
        onClick={onClick}
        className={`flex items-center gap-3 px-4 py-2 rounded-md text-sm transition-colors duration-200 w-full ${
          isActive
            ? effectiveIsDark
              ? "bg-gray-700 text-indigo-400"
              : "bg-gray-100 text-indigo-600"
            : effectiveIsDark
            ? "text-gray-300 hover:bg-gray-700 hover:text-white"
            : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        }`}
        aria-label={title}
      >
        {image ? (
          <img
            className="w-5 h-5 rounded-full flex-shrink-0"
            src={image}
            alt={`${title} icon`}
          />
        ) : (
          logo && <span className="flex-shrink-0">{logo}</span>
        )}
        <span className="truncate">{title}</span>
      </Link>
    </li>
  );
};

export default ChannelList;
